export const DATA_BROKER_SORTS = [
  { key: "slug_asc", label: "Slug, A-Z" },
  { key: "slug_desc", label: "Slug, Z-A" },
  { key: "name_asc", label: "Name, A-Z" },
  { key: "name_desc", label: "Name, Z-A" },
  { key: "created_at_asc", label: "Created, oldest first" },
  { key: "created_at_desc", label: "Created, newest first" },
] as const;

export type DataBrokerSort = (typeof DATA_BROKER_SORTS)[number]["key"];
